export default "__VITE_ASSET__b75cc66e__"